// @flow

import React, { useState } from 'react';
import type { SearchableTextInputProps } from '../../../utils/types';

const SearchableTextInput = ({
  onUpdateValue,
  translations,
}: SearchableTextInputProps) => {
  const [data, setData] = useState({ value: '', timeout: 0 });
  const updateValue = (value: string): void => {
    if (data.timeout) {
      clearInterval(data.timeout);
    }
    const timeout = setTimeout(() => {
      onUpdateValue({ SearchableText: value });
    }, 1000);
    setData({ value, timeout });
  };
  return (
    <input
      type="text"
      value={data.value}
      placeholder={
        translations ? translations.search_word_placeholder : 'Search word...'
      }
      onChange={e => updateValue(e.target.value)}
    />
  );
};

export default SearchableTextInput;
